import {
  INITIAL_STATE,
  CHECK_CONSENT_EXPIRY,
  CLEAR_CONSENT_TYPE_DATA,
  DISMISS_CONSENT_BOX,
  SAVE_ALL_CONSENTS,
  SAVE_SINGLE_CONSENT,
  UNDISMISS_CONSENT_BOX,
} from './actions';

declare global {
  interface Window {
    dataLayer?: object[];
  }
}

function reducers(state, action) {
  switch (action.type) {
  case CHECK_CONSENT_EXPIRY: {
    const now = Date.now();
    const consentsData = { ...state.consents };
    for (const key in consentsData) {
      // We can only expire non-session consents
      if (key !== 'consentBoxDismissed'
        && (consentsData[key]?.consentLifetime ?? 0) > 0
        && (consentsData[key]?.consentExpirationDate ?? 0) <= now
      ) {
        delete consentsData[key];
        consentsData.consentBoxDismissed = false;
      }
    }
    return {
      ...state,
      consents: consentsData,
    };
  }

  case CLEAR_CONSENT_TYPE_DATA: {
    const newClearedConsents = { ...state.consents };
    delete newClearedConsents[action.payload];
    return {
      ...state,
      consents: newClearedConsents,
    };
  }

  case SAVE_ALL_CONSENTS: {
    const newAllConsents = { ...state.consents, ...action.payload };
    return {
      ...state,
      consents: newAllConsents,
    };
  }

  case SAVE_SINGLE_CONSENT: {
    const newConsentsWithSingleConsentChange = { ...state.consents };
    newConsentsWithSingleConsentChange[action.payload.consentType] = { ...action.payload.consentData };
    return {
      ...state,
      consents: newConsentsWithSingleConsentChange,
    };
  }

  case DISMISS_CONSENT_BOX: {
    const newDismissedBoxConsents = { ...state.consents };
    newDismissedBoxConsents.consentBoxDismissed = true;
    return {
      ...state,
      consents: newDismissedBoxConsents,
    };
  }

  case UNDISMISS_CONSENT_BOX: {
    const newUndismissedBoxConsents = { ...state.consents };
    newUndismissedBoxConsents.consentBoxDismissed = false;
    return {
      ...state,
      consents: newUndismissedBoxConsents,
    };
  }
  }

  return state;
}

let initialStatePushedToDataLayer = false;

export default function consentReducersExport(state = INITIAL_STATE, action) {
  const reducedState = reducers(state, action);

  // TODO migrate to state emitter
  if (typeof window.dataLayer === 'object' && (!initialStatePushedToDataLayer || (reducedState.consents.consentBoxDismissed !== undefined && reducedState.consents.consentBoxDismissed))) {
    window.dataLayer.push({ event: 'consent-changed', ...reducedState.consents });
    initialStatePushedToDataLayer = true;
  }

  return reducedState;
}
